module.exports = __webpack_public_path__ + "static/img/home_logo_1.07f8afb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_logo_1.png
// module id = SPRy
// module chunks = 3